export const AppRoutes = {
    introduction: '/',
    gettingStarted: '/getting-started',
    api: '/api',
    integration: '/integration',
    CEXIntegration: '/CEXIntegration',
    DEXIntegration: '/DEXIntegration'
}
